<template>
    <div class="h-full flex flex-col justify-end">
        <div class="h-2/3 flex flex-col justify-center items-center">
            <div class="h-full flex flex-col space-y-4 items-center justify-center" v-if="gamer.length == 1">
                <div class="flex items-center space-x-3 games-elements-text-color-primary">
                    <div class="font-bold text-6xl">{{gamer[0].point}}</div>
                    <div class="font-bold  text-4xl lg:text-5xl 2xl:text-6xl">
                        {{ $t('elements_title_point') }}
                    </div>
                </div>
                <div v-if="newRecord">
                    <div class="text-center text-black flex text-2xl lg:text-3xl 2xl:text-5xl space-x-2 items-center">
                        <div>{{ $t('elements_description_record') }}</div>
                    </div>
                </div>
            </div>

            <!-- iki oyuncu -->
            <div class="h-full flex flex-col items-center justify-center" :class="phoneScreen.landscape && 'space-y-3 md:space-y-6 xl:space-y-12' || 'space-y-12'" v-if="gamer.length == 2">
                <div class="text-center">
                    <div class="text-secondary">
                        <div v-if="gamer[0]?.point > gamer[1]?.point">
                            <div class="font-bold games-elements-text-color-primary text-2xl">{{ $t('elements_title_winning') }}</div>
                            <div class="font-bold text-5xl">{{ $t('elements_description_first_multiplier') }}</div>
                        </div>
                        <div v-if="gamer[0]?.point < gamer[1]?.point">
                            <div class="font-bold games-elements-text-color-primary text-2xl">{{ $t('elements_title_winning') }}</div>
                            <div class="font-bold text-5xl">{{ $t('elements_description_second_multiplier') }}</div>
                        </div>
                        <div class="font-bold text-5xl" v-if="gamer[0]?.point == gamer[1]?.point">
                            {{ $t('elements_result_draw') }}
                        </div>
                    </div>
                </div>
                <div class="w-full">
                    <div class="grid grid-cols-2 gap-x-8 gap-y-4 text-center">
                        <div v-for="i in 2" :key="i" class="font-bold games-elements-text-color-primary text-2xl">
                            {{ $t('elements_description_gamer', {gamer: i}) }}
                        </div>
                        <div v-for="i in 2" :key="i" class="games-elements-text-color-primary font-bold">
                            <span class="font-bold text-4xl">{{ gamer[i - 1]?.point }}</span> {{ $t('elements_title_point') }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-center items-center" :class="phoneScreen.landscape ? 'my-5 2xl:my-20' : 'my-20'">
                <div class="text-xl font-bold cursor-pointer games-elements-bg-light text-white  px-4 py-2 rounded-lg"  @click="setScreen('home')">
                    {{ $t('elements_button_back') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {computed, ref} from "vue"
import {useScreen} from 'vue-screen'

const phoneScreen = useScreen()

const emit = defineEmits(['screen', 'score'])
const props = defineProps(['gamer', 'time', 'heightScore'])
const newRecord = ref(false)

const setStoreScore = () => {
    if(props.gamer.length == 1){
        if (props.gamer[0].point > getStorePoint.value) {
            newRecord.value = true
            emit('score', props.gamer[0].point)
        }
    }
}

const getStorePoint = computed(() => {
    return props.heightScore;
})

setStoreScore()

const setScreen = (screen) => {
    emit('screen', screen)
}
</script>
